export const getChannelFromParam = () => {
  let channel;

  // Check channel parameter to identify the source
  try {
    const url = new URL(window.location);

    channel = url.searchParams.get('channel');
  } catch (e) {
    // do nothing
  }

  if (!channel) {
    // Also check the referrer to retrieve the channel in case the merchant is from "https://paidy.com/merchant/application?channel=xxxxx"
    const referrer = document.referrer;

    if (referrer) {
      try {
        const url = new URL(referrer);

        channel = url.searchParams.get('channel');
      } catch (e) {
        // do nothing
      }
    }
  }

  return channel;
};

export default { getChannelFromParam };
